import { CALL_API } from './api.middleware';
import jwt_decode from 'jwt-decode';

const VERIFIER_SERVICE_URL = process.env.REACT_APP_VERIFIER_SERVICE_URL;
const USER_SERVICE_URL = process.env.REACT_APP_USER_SERVICE_URL;
const CATALOG_SERVICE_URL = process.env.REACT_APP_CATALOG_SERVICE_URL;
const ORDER_SERVICE_URL = process.env.REACT_APP_ORDER_SERVICE_URL;
const CLIENT_OAUTH = process.env.REACT_APP_CLIENT_OAUTH;
const CLIENT_SECRET_OAUTH = process.env.REACT_APP_CLIENT_SECRET_OAUTH;
const CLIENT_USER = process.env.REACT_APP_CLIENT_USER;
const CLIENT_PASS = process.env.REACT_APP_CLIENT_PASS;
const UTILS_SERVICE_URL = process.env.REACT_APP_UTILS_SERVICE_URL;

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

const clientAuthBase64 = btoa(`${CLIENT_OAUTH}:${CLIENT_SECRET_OAUTH}`);

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

function requestLogin(creds) {
  return {
    type: LOGIN_REQUEST,
    isFetching: true,
    isAuthenticated: false,
    creds
  };
}

function receiveLogin(user) {
  return {
    type: LOGIN_SUCCESS,
    isFetching: false,
    isAuthenticated: true,
    // id_token: user.id_token
    id_token: user.jti
  };
}

function loginError(error) {
  const message = typeof error === 'string' ? error : error && error.message;
  const errorCode = typeof error === 'string' ? undefined : error && error.errorCode;
  return {
    type: LOGIN_FAILURE,
    isFetching: false,
    isAuthenticated: false,
    message,
    errorCode
  };
}

function succesToken({ user, response, dispatch, posId }) {
  if (!response.ok) {
    // If there was a problem, we want to
    // dispatch the error condition
    dispatch(loginError(user.message));
    return Promise.reject(user);
  } else {
    // If login was successful, set the token in local storage
    sessionStorage.setItem('id_token', user.jti);
    sessionStorage.setItem('access_token', user.access_token);
    sessionStorage.setItem('refresh_token', user.refresh_token);

    // Dispatch the success action
    dispatch(receiveLogin(user, posId));
  }
  return response;
}

export function loginVerifierUser(creds) {
  creds = {
    username: (creds && creds.username) || CLIENT_USER,
    password: (creds && creds.password) || CLIENT_PASS
  };

  let config = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      grant_type: 'password',
      username: creds.username,
      password: creds.password,
      module: 'verifier'
    })
  };

  return dispatch => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestLogin(creds));

    return fetch(`${USER_SERVICE_URL}/api/oauth/loginModule`, config)
      .then(response => response.json().then(user => ({ user, response })))
      .then(({ user, response }) => {
        if (!response.ok) {
          return dispatch(
            loginError({
              message: user.message || user.error_description,
              errorCode: user.errorCode
            })
          );
        } else {
          // If login was successful, set the token in local storage
          sessionStorage.setItem('id_token', user.jti);
          sessionStorage.setItem('access_token', user.access_token);
          if (user.refresh_token) {
            sessionStorage.setItem('refresh_token', user.refresh_token);
          }

          //change this when microservice has changed
          sessionStorage.setItem('id_pos', user.posAllowed[0]);
          const decoded = jwt_decode(user.access_token);
          sessionStorage.setItem('roles', JSON.stringify(decoded.authorities));

          // Dispatch the success action
          succesToken({ user, response, dispatch });
          return dispatch(receiveLogin(user));
        }
      })
      .catch(err => console.log('Error: ', err));
  };
}
export const refreshUser = posId => dispatch => {
  const refreshToken = sessionStorage.getItem('refresh_token');
  if (refreshToken) {
    let config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Basic ${clientAuthBase64}`
      },
      body: `grant_type=refresh_token&refresh_token=${refreshToken}`
    };

    // We dispatch requestLogin to kickoff the call to the API
    return fetch(`${USER_SERVICE_URL}/oauth/token`, config).then(response => {
      if ([401, 403].indexOf(response.status) !== -1) {
        // window.location.href="/";

      } else {
        return response
          .json()
          .then(user => ({ user, response }))
          .then(({ user, response }) => {
            return succesToken({ user, response, dispatch, posId });
          });
      }
    });
  }
};


export const CLIENT_REQUEST = 'CLIENT_REQUEST';
export const CLIENT_SUCCESS = 'CLIENT_SUCCESS';
export const CLIENT_FAILURE = 'CLIENT_FAILURE';

export function fetchClient(clientId) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/clients/${clientId}`,
      authenticated: true,
      types: [CLIENT_REQUEST, CLIENT_SUCCESS, CLIENT_FAILURE]
    }
  };
}

//TODO move this block of api calls
/************VERIFIER CALLS*******************/

/* DATA MASTER */
export const BUYER_TYPES_REQUEST = 'BUYER_TYPES_REQUEST';
export const BUYER_TYPES_SUCCESS = 'BUYER_TYPES_SUCCESS';
export const BUYER_TYPES_FAILURE = 'BUYER_TYPES_FAILURE';

export function fetchBuyerTypes() {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/buyerTypes`,
      authenticated: true,
      types: [BUYER_TYPES_REQUEST, BUYER_TYPES_SUCCESS, BUYER_TYPES_FAILURE]
    }
  };
}

export const EXTRAS_REQUEST = 'EXTRAS_REQUEST';
export const EXTRAS_SUCCESS = 'EXTRAS_SUCCESS';
export const EXTRAS_FAILURE = 'EXTRAS_FAILURE';

export function fetchExtras() {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/extras`,
      authenticated: true,
      types: [EXTRAS_REQUEST, EXTRAS_SUCCESS, EXTRAS_FAILURE]
    }
  };
}

export const PROMOTIONS_REQUEST = 'PROMOTIONS_REQUEST';
export const PROMOTIONS_SUCCESS = 'PROMOTIONS_SUCCESS';
export const PROMOTIONS_FAILURE = 'PROMOTIONS_FAILURE';

export function fetchPromotions() {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/promotions`,
      authenticated: true,
      types: [PROMOTIONS_REQUEST, PROMOTIONS_SUCCESS, PROMOTIONS_FAILURE]
    }
  };
}

export const VENUE_CAPACITIES_REQUEST = 'VENUE_CAPACITIES_REQUEST';
export const VENUE_CAPACITIES_SUCCESS = 'VENUE_CAPACITIES_SUCCESS';
export const VENUE_CAPACITIES_FAILURE = 'VENUE_CAPACITIES_FAILURE';

export function fetchVenueCapacities() {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/venueCapacities`,
      authenticated: true,
      types: [
        VENUE_CAPACITIES_REQUEST,
        VENUE_CAPACITIES_SUCCESS,
        VENUE_CAPACITIES_FAILURE
      ]
    }
  };
}

export const ACCESSES_REQUEST = 'ACCESSES_REQUEST';
export const ACCESSES_SUCCESS = 'ACCESSES_SUCCESS';
export const ACCESSES_FAILURE = 'ACCESSES_FAILURE';

export function fetchAccesses() {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/accesses`,
      authenticated: true,
      types: [ACCESSES_REQUEST, ACCESSES_SUCCESS, ACCESSES_FAILURE]
    }
  };
}

export const EVENTS_REQUEST = 'EVENTS_REQUEST';
export const EVENTS_SUCCESS = 'EVENTS_SUCCESS';
export const EVENTS_FAILURE = 'EVENTS_FAILURE';

export function fetchEvents(date) {
  const config = {
    params: {
      startDateFrom: date,
      startDateTo: date
    }
  };

  //TODO changed the way to send params, config is not working currently
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/events?startDateFrom=${date}&startDateTo=${date}`,
      config,
      authenticated: true,
      types: [EVENTS_REQUEST, EVENTS_SUCCESS, EVENTS_FAILURE]
    }
  };
}

/* UNIQUE EVENT */

export const EVENT_REQUEST = 'EVENT_REQUEST';
export const EVENT_SUCCESS = 'EVENT_SUCCESS';
export const EVENT_FAILURE = 'EVENT_FAILURE';

export function fetchEvent(eventId) {
  const config = {};

  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/events/${eventId}`,
      config,
      authenticated: true,
      types: [EVENT_REQUEST, EVENT_SUCCESS, EVENT_FAILURE]
    }
  };
}

/* VALIDATION */

export const VALIDATION_REQUEST = 'VALIDATION_REQUEST';
export const VALIDATION_SUCCESS = 'VALIDATION_SUCCESS';
export const VALIDATION_FAILURE = 'VALIDATION_FAILURE';

export function fetchValidation(validationRequest) {
  console.log(validationRequest);

  let config = {
    method: 'POST',
    body: JSON.stringify(validationRequest)
  };

  return {
    [CALL_API]: {
      endpoint: `${VERIFIER_SERVICE_URL}/validations/validate`,
      config,
      authenticated: true,
      types: [VALIDATION_REQUEST, VALIDATION_SUCCESS, VALIDATION_FAILURE]
    }
  };
}

export const VALIDATIONS_REQUEST = 'VALIDATIONS_REQUEST';
export const VALIDATIONS_SUCCESS = 'VALIDATIONS_SUCCESS';
export const VALIDATIONS_FAILURE = 'VALIDATIONS_FAILURE';

export function fetchValidations(idValue, type) {
  let config = {
    params: {
      ticketId: idValue,
      ticketType: type
    }
  };

  return {
    [CALL_API]: {
      endpoint: `${VERIFIER_SERVICE_URL}/validations?ticketId=${idValue}&ticketType=${type}`,
      config,
      authenticated: true,
      types: [VALIDATIONS_REQUEST, VALIDATIONS_SUCCESS, VALIDATIONS_FAILURE]
    }
  };
}

/* TICKET INFO */

export const TICKET_INFO_REQUEST = 'TICKET_INFO_REQUEST';
export const TICKET_INFO_SUCCESS = 'TICKET_INFO_SUCCESS';
export const TICKET_INFO_FAILURE = 'TICKET_INFO_FAILURE';

export function fetchTicketInfo(ticketId) {
  let request;
  if (isNaN(ticketId)){
	  request=`barcode=${ticketId}`
  }else{
	  request= `ticketId=${ticketId}`
  }
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL}/tickets?${request}`,
      authenticated: true,
      types: [TICKET_INFO_REQUEST, TICKET_INFO_SUCCESS, TICKET_INFO_FAILURE]
    }
  };
}

export const TICKET_GROUP_INFO_REQUEST = 'TICKET_GROUP_INFO_REQUEST';
export const TICKET_GROUP_INFO_SUCCESS = 'TICKET_GROUP_INFO_SUCCESS';
export const TICKET_GROUP_INFO_FAILURE = 'TICKET_GROUP_INFO_FAILURE';

export function fetchTicketGroupInfo(ticketGroupId) {
	let request;
	if (isNaN(ticketGroupId)){
		request=`barcode=${ticketGroupId}`
	}else{
		request=`ticketId=${ticketGroupId}`
	}
  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL}/tickets/group?${request}`,
      authenticated: true,
      types: [
        TICKET_GROUP_INFO_REQUEST,
        TICKET_GROUP_INFO_SUCCESS,
        TICKET_GROUP_INFO_FAILURE
      ]
    }
  };
}

/* VERIFIER CONFIG */

export const VERIFIER_CONFIG_REQUEST = 'VERIFIER_CONFIG_REQUEST';
export const VERIFIER_CONFIG_SUCCESS = 'VERIFIER_CONFIG_SUCCESS';
export const VERIFIER_CONFIG_FAILURE = 'VERIFIER_CONFIG_FAILURE';

export function fetchVerifierConfig(verifierId) {
  return {
    [CALL_API]: {
      endpoint: `${VERIFIER_SERVICE_URL}/verifiers/${verifierId}`,
      authenticated: true,
      types: [
        VERIFIER_CONFIG_REQUEST,
        VERIFIER_CONFIG_SUCCESS,
        VERIFIER_CONFIG_FAILURE
      ]
    }
  };
}

export const PUT_CONFIGURATION_REQUEST = 'PUT_CONFIGURATION_REQUEST';
export const PUT_CONFIGURATION_SUCCESS = 'PUT_CONFIGURATION_SUCCESS';
export const PUT_CONFIGURATION_FAILURE = 'PUT_CONFIGURATION_FAILURE';

export function fetchPutVerifierConfig(verifierConfiguration, verifierId) {
  let config = {
    method: 'PUT',
    body: JSON.stringify(verifierConfiguration)
  };

  return {
    [CALL_API]: {
      endpoint: `${VERIFIER_SERVICE_URL}/verifiers/${verifierId}`,
      config,
      authenticated: true,
      types: [
        PUT_CONFIGURATION_REQUEST,
        PUT_CONFIGURATION_SUCCESS,
        PUT_CONFIGURATION_FAILURE
      ]
    }
  };
}

/* VERIFIERS */

export const VERIFIERS_REQUEST = 'VERIFIERS_REQUEST';
export const VERIFIERS_SUCCESS = 'VERIFIERS_SUCCESS';
export const VERIFIERS_FAILURE = 'VERIFIERS_FAILURE';

export function fetchVerifiers() {
  return {
    [CALL_API]: {
      endpoint: `${VERIFIER_SERVICE_URL}/verifiers?serialNumber=web`,
      authenticated: true,
      types: [VERIFIERS_REQUEST, VERIFIERS_SUCCESS, VERIFIERS_FAILURE]
    }
  };
}

/* REPORTS */

export const REPORTS_METABASE_REQUEST = 'REPORTS_METABASE_REQUEST';
export const REPORTS_METABASE_SUCCESS = 'REPORTS_METABASE_SUCCESS';
export const REPORTS_METABASE_FAILURE = 'REPORTS_METABASE_FAILURE';

export function fetchDashboardReport(metabaseURL, request) {
  let config = {
    method: 'POST',
    body: JSON.stringify(request)
  };

  return {
    [CALL_API]: {
      endpoint: `${metabaseURL}`,
      config,
      authenticated: true,
      types: [
        REPORTS_METABASE_REQUEST,
        REPORTS_METABASE_SUCCESS,
        REPORTS_METABASE_FAILURE
      ]
    }
  };
}

export const REPORTS_REQUEST = 'REPORTS_REQUEST';
export const REPORTS_SUCCESS = 'REPORTS_SUCCESS';
export const REPORTS_FAILURE = 'REPORTS_FAILURE';

export function fetchReports() {
  return {
    [CALL_API]: {
      endpoint: `${UTILS_SERVICE_URL}/report`,
      authenticated: true,
      types: [REPORTS_REQUEST, REPORTS_SUCCESS, REPORTS_FAILURE]
    }
  };
}

/*********************************************/
export const LANGUAGE_REQUEST = 'LANGUAGE_REQUEST';
export const LANGUAGE_SUCCESS = 'LANGUAGE_SUCCESS';
export const LANGUAGE_FAILURE = 'LANGUAGE_FAILURE';

export function fetchLanguages(clientId) {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/clients/${clientId}/language`,
      authenticated: true,
      types: [LANGUAGE_REQUEST, LANGUAGE_SUCCESS, LANGUAGE_FAILURE]
    }
  };
}

export const POINT_OF_SALE_REQUEST = 'POINT_OF_SALE_REQUEST';
export const POINT_OF_SALE_SUCCESS = 'POINT_OF_SALE_SUCCESS';
export const POINT_OF_SALE_FAILURE = 'POINT_OF_SALE_FAILURE';

export function fetchPointOfSale() {
  return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/pointOfSales`,
      authenticated: true,
      types: [
        POINT_OF_SALE_REQUEST,
        POINT_OF_SALE_SUCCESS,
        POINT_OF_SALE_FAILURE
      ]
    }
  };
}

function isRequired() {
  throw new Error('Required param');
}

export const RESERVATION_REQUEST = 'RESERVATION_REQUEST';
export const RESERVATION_SUCCESS = 'RESERVATION_SUCCESS';
export const RESERVATION_FAILURE = 'RESERVATION_FAILURE';

export function fetchReservation({
  productId = isRequired(),
  eventIdList = isRequired(),
  ticketTypeNumberMap = isRequired(),
  ...values
}) {
  const body = {
    productId,
    eventIdList,
    ticketTypeNumberMap,
    ...values
  };

  let config = {
    method: 'POST',
    body: JSON.stringify(body)
  };

  return {
    [CALL_API]: {
      endpoint: `${ORDER_SERVICE_URL}/reservations`,
      // params,
      config,
      authenticated: true,
      types: [RESERVATION_REQUEST, RESERVATION_SUCCESS, RESERVATION_FAILURE]
    }
  };
}

export function openShelly(endpoint) {
  let config = {
    headers:{
      'Access-Control-Allow-Origin': '*',
      'Accept': '*/*'
    },
  };
  return {
    [CALL_API]: {
      endpoint: endpoint,
      authenticated: false,
      config,
      types: ['SHELLY_REQUEST', 'SHELLY_SUCCESS', 'SHELLY_FAILURE']
    }
  };
}
